import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { ethernetTitle } from 'console/shared/components/indicators/ethernet/utils/ethernet-utils';
import { Box } from '@mui/material';
import { TypographyWithCopy } from 'console/shared/components/fields';
import { usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { select_device_ethernet_state } from 'console/shared/components/indicators/gsm/utils/selectors';
import { EthernetBodyComponent } from 'z3k-settings/components/main-settings/cards/ethernet-settings';
export const EthernetTooltip = memo(function EthernetTooltip(props) {
    const { Tooltip, device_id } = props;
    const { online, connected, ethernet_state } = usePartialAppSelector(select_device_ethernet_state, device_id);
    const title = useMemo(() => ethernetTitle(online, connected), [online, connected]);
    return (_jsx(Tooltip, { children: _jsxs(Box, { width: "100%", children: [_jsx(TypographyWithCopy, { label: "\u0421\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435", value: title, sx: { mb: 2 } }), connected && ethernet_state && (_jsx(EthernetBodyComponent, { ethernet_state: ethernet_state }))] }) }));
});
